export default {
  section1: [
    {
      name: "firstName0",
      label: "First Name",
      type: "textfield",
      placeholder: "Add",
      maxLength: 40,
      required: true,
      validator: "isString",
      label_lang: "SplznContactFName",
      key: "pg1_1_1",
      useLabel: true,
      rowStyle: { paddingBottom: "3%" },
      fieldLableProps: { style: { fontSize: "13.5px" }, necessity: "required" },
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "lastName0",
      label: "Last Name",
      type: "textfield",
      placeholder: "Add",
      maxLength: 80,
      required: true,
      validator: "isString",
      label_lang: "SplznContactLName",
      key: "pg1_1_2",
      useLabel: true,
      rowStyle: { paddingBottom: "3%" },
      fieldLableProps: { style: { fontSize: "13.5px" }, necessity: "required" },
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "email0",
      label: "E-mail Address",
      label_lang: "SplznEmail",
      maxLength: 80,
      type: "textfield",
      placeholder: "Add",
      required: true,
      validator: "isEmailDomain",
      key: "pg1_1_3",
      useLabel: true,
      fieldLableProps: { style: { fontSize: "13.5px" }, necessity: "required" },
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section2: {
    requiredFields: [
      {
        name: "firstName1",
        label: "First Name",
        type: "textfield",
        placeholder: "Add",
        maxLength: 40,
        required: true,
        validator: "isString",
        label_lang: "SplznContactFName",
        key: "pg1_2_1",
        useLabel: true,
        rowStyle: { paddingBottom: "3%" },
        fieldLableProps: {
          style: { fontSize: "13.5px" },
          necessity: "required",
        },
        gridRowProps: {},
        gridColumnProps: {},
      },
      {
        name: "lastName1",
        label: "Last Name",
        type: "textfield",
        placeholder: "Add",
        maxLength: 80,
        required: true,
        validator: "isString",
        label_lang: "SplznContactLName",
        key: "pg1_2_2",
        useLabel: true,
        rowStyle: { paddingBottom: "3%" },
        fieldLableProps: {
          style: { fontSize: "13.5px" },
          necessity: "required",
        },
        gridRowProps: {},
        gridColumnProps: {},
      },
      {
        name: "email1",
        label: "E-mail Address",
        label_lang: "SplznEmail",
        type: "textfield",
        maxLength: 80,
        placeholder: "Add",
        required: true,
        validator: "isEmailDomain",
        key: "pg1_2_3",
        useLabel: true,
        fieldLableProps: {
          style: { fontSize: "13.5px" },
          necessity: "required",
        },
        gridRowProps: {},
        gridColumnProps: {},
      },
    ],
    notRequiredFields: [
      {
        name: "firstName1",
        label: "First Name",
        type: "textfield",
        placeholder: "Add",
        maxLength: 40,
        validator: "isString",
        label_lang: "SplznContactFName",
        key: "pg1_2_1",
        useLabel: true,
        rowStyle: { paddingBottom: "3%" },
        fieldLableProps: { style: { fontSize: "13.5px" } },
        gridRowProps: {},
        gridColumnProps: {},
      },
      {
        name: "lastName1",
        label: "Last Name",
        type: "textfield",
        placeholder: "Add",
        maxLength: 80,
        validator: "isString",
        label_lang: "SplznContactLName",
        key: "pg1_2_2",
        useLabel: true,
        rowStyle: { paddingBottom: "3%" },
        fieldLableProps: { style: { fontSize: "13.5px" } },
        gridRowProps: {},
        gridColumnProps: {},
      },
      {
        name: "email1",
        label: "E-mail Address",
        label_lang: "SplznEmail",
        type: "textfield",
        maxLength: 80,
        placeholder: "Add",
        validator: "isEmailDomain",
        key: "pg1_2_3",
        useLabel: true,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        gridRowProps: {},
        gridColumnProps: {},
      },
    ],
  },

  questions: {
    en_us: [
      {
        type: "radiogroup",
        name: "question_us_1",
        required: true,
        label:
          "1. What was your Organization's total education revenue for the last 12 months?(USD)",
        validator: "isString",
        fieldLableProps: {
          style: { color: "#323232", fontSize: "16.5px" },
          necessity: "required",
        },
        vertical: true,
        useLabel: true,
        key: "pg_us_1",
        rowStyle: { margin: "1px" },
        addNewLineBelow: true,
        //"label_lang" :  "OnbrdInterimUplevelHeader" ,
        radios: [
          {
            label: "< $100,000",
            value: "< $100,000",
            type: "radio",
            useLabel: true,
          },
          {
            label: "$100,000 - $249,999",
            value: "$100,000 - $249,999",
            type: "radio",
            useLabel: true,
          },
          {
            label: "$250,000 - $499,999",
            value: "$250,000 - $499,999",
            type: "radio",
            useLabel: true,
          },
          {
            label: "$500,000 - $999,999",
            value: "$500,000 - $999,999",
            type: "radio",
            useLabel: true,
          },
          {
            label: "$1,000,000 - $4,999,999",
            value: "$1,000,000 - $4,999,999",
            type: "radio",
            useLabel: true,
          },
          {
            label: "$5,000,000 - $9,999,999",
            value: "$5,000,000 - $9,999,999",
            type: "radio",
            useLabel: true,
          },
          {
            label: "$10,000,000 +",
            value: "$10,000,000 +",
            type: "radio",
            useLabel: true,
          },
        ],
      },
      {
        type: "none",
        fieldLableProps: {
          style: { color: "#323232", fontSize: "16.5px" },
          necessity: "required",
        },
        name: "question_us_2_onlyQuestion",
        label:
          "2. What is your organization's total number of sales representatives actively engaged in the education? Enter 0 if not applicable",
        useLabel: true,
        rowStyle: { margin: "1px" },
      },
      [
        {
          name: "K-12",
          label: "K-12",
          type: "textfield",
          maxLength: 3,
          required: true,
          validator: "isString",
          placeholder: "0",
          label_lang: "",
          key: "pg1_4",
          useLabel: true,
          fieldLableProps: { style: { fontSize: "13.5px" } },
          gridRowProps: {},
          gridColumnProps: {},
        },
        {
          name: "HigherEducation",
          label: "Higher Education",
          type: "textfield",
          maxLength: 3,
          required: true,
          validator: "isString",
          placeholder: "0",
          label_lang: "",
          key: "pg1_5",
          useLabel: true,
          fieldLableProps: { style: { fontSize: "13.5px" } },
          gridRowProps: {},
          gridColumnProps: {},
        },
        {
          name: "NonProfit",
          label: "Non-Profit",
          type: "textfield",
          maxLength: 3,
          required: true,
          validator: "isString",
          placeholder: "0",
          label_lang: "",
          key: "pg1_6",
          useLabel: true,
          fieldLableProps: { style: { fontSize: "13.5px" } },
          gridRowProps: {},
          gridColumnProps: {},
        },
      ],
      {
        type: "none",
        fieldLableProps: {
          style: { color: "#323232", fontSize: "16.5px" },
          necessity: "required",
        },
        name: "question_us_3_onlyQuestion",
        label:
          "3. Provide three (3) customer references who are currently utilizing your solution.",
        useLabel: true,
        rowStyle: { margin: "1px" },
        addNewLineAbove: true,
      },
      [
        {
          type: "none",
          fieldLableProps: { style: { color: "#323232", fontSize: "16.5px" } },
          name: "span2",
          label: "Customer Reference 1",
          useLabel: true,
        },
        {
          type: "none",
          fieldLableProps: { style: { color: "#323232", fontSize: "16.5px" } },
          name: "span2",
          label: "Customer Reference 2",
          useLabel: true,
        },
        {
          type: "none",
          fieldLableProps: { style: { color: "#323232", fontSize: "16.5px" } },
          name: "span2",
          label: "Customer Reference 3",
          useLabel: true,
        },
      ],
      [
        [
          {
            name: "Organization1",
            label: "Organization",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isString",
            label_lang: "",
            key: "pg1_7_1",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
          {
            name: "Name1",
            label: "Name",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isString",
            label_lang: "",
            key: "pg1_7_2",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
          {
            name: "Title1",
            label: "Title",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isString",
            label_lang: "",
            key: "pg1_7_3",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
          {
            name: "Phone1",
            label: "Phone",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isValidPhoneNumber",
            label_lang: "",
            key: "pg1_7_4",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
        ],
        [
          {
            name: "Organization2",
            label: "Organization",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isString",
            label_lang: "",
            key: "pg1_8_1",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
          {
            name: "Name2",
            label: "Name",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isString",
            label_lang: "",
            key: "pg1_8_2",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
          {
            name: "Title2",
            label: "Title",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isString",
            label_lang: "",
            key: "pg1_8_3",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
          {
            name: "Phone2",
            label: "Phone",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isValidPhoneNumber",
            label_lang: "",
            key: "pg1_8_4",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
        ],
        [
          {
            name: "Organization3",
            label: "Organization",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isString",
            label_lang: "",
            key: "pg1_9_1",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
          {
            name: "Name3",
            label: "Name",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isString",
            label_lang: "",
            key: "pg1_9_2",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
          {
            name: "Title3",
            label: "Title",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isString",
            label_lang: "",
            key: "pg1_9_3",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
          {
            name: "Phone3",
            label: "Phone",
            type: "textfield",
            placeholder: "Add",
            maxLength: 40,
            required: true,
            validator: "isValidPhoneNumber",
            label_lang: "",
            key: "pg1_9_4",
            useLabel: true,
            rowStyle: { paddingBottom: "3%" },
            fieldLableProps: { style: { fontSize: "13.5px" } },
          },
        ],
      ],
    ],
    en_xap: [
      {
        type: "radiogroup",
        name: "question_1",
        required: true,
        label:
          "1. What percentage of your total revenue was for education products (software and/or hardware)?",
        questionNumber: 1,
        validator: "isString",
        fieldLableProps: {
          style: { color: "#323232", fontSize: "16.5px" },
          necessity: "required",
        },
        vertical: true,
        useLabel: true,
        key: "pg_qs_1",
        rowStyle: { margin: "1px" },
        addNewLineBelow: true,
        //"label_lang" :  "OnbrdInterimUplevelHeader" ,
        radios: [
          {
            label: "I have not sold any education products before",
            value: "I have not sold any education products before",
            type: "radio",
            useLabel: true,
          },
          {
            label: "< 20% of total revenue",
            value: "< 20% of total revenue",
            type: "radio",
            useLabel: true,
          },
          {
            label: "21 – 40% of total revenue",
            value: "21 – 40% of total revenue",
            type: "radio",
            useLabel: true,
          },
          {
            label: "> 40% of total revenue",
            value: "> 40% of total revenue",
            type: "radio",
            useLabel: true,
          },
        ],
      },
      {
        type: "none",
        fieldLableProps: {
          style: { color: "#323232", fontSize: "16.5px" },
          necessity: "required",
        },
        name: "span1",
        label:
          "2. What percentage of your education revenue came from the following customer types? Enter 0 if not applicable.",
        useLabel: true,
        rowStyle: { margin: "1px" },
      },
      [
        [
          {
            name: "K12Institutions",
            label: "K-12 institutions (in %)",
            type: "textfield",
            maxLength: 3,
            questionNumber: 4,
            required: true,
            validator: "isString",
            placeholder: "0",
            label_lang: "",
            key: "pg1_2_1",
            useLabel: true,
            fieldLableProps: { style: { fontSize: "13.5px" } },
            gridRowProps: {},
            gridColumnProps: { size: [12, 4, 4, 4] },
          },
          {
            name: "K12IndividualsFaculty",
            label: "K-12 individuals (students/faculty) (in %)",
            type: "textfield",
            maxLength: 3,
            required: true,
            validator: "isString",
            placeholder: "0",
            label_lang: "",
            key: "pg1_2_2",
            useLabel: true,
            fieldLableProps: { style: { fontSize: "13.5px" } },
            gridRowProps: {},
            gridColumnProps: { size: [12, 4, 4, 4] },
          },
          {
            name: "HigherEducationInstitutions",
            label: "Higher education institutions (in %)",
            type: "textfield",
            maxLength: 3,
            required: true,
            validator: "isString",
            placeholder: "0",
            label_lang: "",
            key: "pg1_2_3",
            useLabel: true,
            fieldLableProps: { style: { fontSize: "13.5px" } },
            gridRowProps: {},
            gridColumnProps: { size: [12, 4, 4, 4] },
          },
          {
            name: "HigherEducationIndividuals",
            label: "Higher education individuals (students/faculty) (in %)",
            type: "textfield",
            maxLength: 3,
            required: true,
            validator: "isString",
            placeholder: "0",
            label_lang: "",
            key: "pg1_2_3",
            useLabel: true,
            fieldLableProps: { style: { fontSize: "13.5px" } },
            gridRowProps: {},
            gridColumnProps: { size: [12, 4, 4, 4] },
          },
        ],
      ],
      {
        type: "radiogroup",
        name: "question_3",
        required: true,
        label:
          "3. What is your company’s total number of sales representatives (outbound sales representatives, inside sales, technical sales, etc) dedicated solely to the education market?",
        validator: "isString",
        fieldLableProps: {
          style: { color: "#323232", fontSize: "16.5px" },
          necessity: "required",
        },
        useLabel: true,
        key: "pg_3",
        vertical: true,
        rowStyle: { margin: "1px" },
        addNewLineAbove: true,
        //"label_lang" :  "OnbrdInterimUplevelHeader" ,
        radios: [
          {
            label: "0",
            value: "0",
            type: "radio",
            useLabel: true,
          },
          {
            label: "1",
            value: "1",
            type: "radio",
            useLabel: true,
          },
          {
            label: "2-3",
            value: "2-3",
            type: "radio",
            useLabel: true,
          },
          {
            label: "4 or more",
            value: "4 or more",
            type: "radio",
            useLabel: true,
          },
        ],
      },
      {
        type: "textfield",
        placeholder: "Add",
        fieldLableProps: {
          style: { color: "#323232", fontSize: "16.5px" },
          necessity: "required",
        },
        name: "question_4",
        label:
          "4. Describe your process(es) to verify whether institutions or individuals (students/faculty) are eligible for education products (such as check that all customers are eligible according to the latest Adobe guidelines, obtain access to a database, catalogue or directory of eligible education organizations made internally or purchased from providers, on-site visits, verify that student/faculty ID (or other documents such as report cards/payslips/etc) is valid and current, etc.)",
        useLabel: true,
        rowStyle: { margin: "1px" },
        addNewLineAbove: true,
        maxLength: 15000,
        required: true,
        validator: "isString",
        label_lang: "",
        key: "pg1_4",
      },
      {
        type: "radiogroup",
        name: "question_5",
        required: true,
        label:
          "5. Do you request AND store documents related to verifying an institute’s or individual’s (student/faculty) eligibility (such as purchase orders on letterheads, school IDs, etc)?",
        validator: "isString",
        fieldLableProps: {
          style: { color: "#323232", fontSize: "16.5px" },
          necessity: "required",
        },
        useLabel: true,
        key: "pg_5",
        rowStyle: { margin: "1px" },
        addNewLineAbove: true,
        //"label_lang" :  "OnbrdInterimUplevelHeader" ,
        radios: [
          {
            label: "Yes",
            value: "Yes",
            type: "radio",
            useLabel: true,
          },
          {
            label: "No",
            value: "No",
            type: "radio",
            useLabel: true,
          },
        ],
      },
      {
        type: "radiogroup",
        name: "question_6",
        required: true,
        label:
          "6. Have there been instances where your organization sold to customers or resellers outside your specified authorised territory?",
        validator: "isString",
        fieldLableProps: {
          style: { color: "#323232", fontSize: "16.5px" },
          necessity: "required",
        },
        useLabel: true,
        key: "pg_6",
        rowStyle: { margin: "1px" },
        addNewLineAbove: true,
        //"label_lang" :  "OnbrdInterimUplevelHeader" ,
        radios: [
          {
            label: "Yes",
            value: "Yes",
            type: "radio",
            useLabel: true,
          },
          {
            label: "No",
            value: "No",
            type: "radio",
            useLabel: true,
          },
        ],
      },
      {
        type: "radiogroup",
        name: "question_7",
        required: true,
        label:
          "7. Do you educate end customers on the importance of not over-deploying/sharing licenses?",
        validator: "isString",
        fieldLableProps: {
          style: { color: "#323232", fontSize: "16.5px" },
          necessity: "required",
        },
        useLabel: true,
        key: "pg_7",
        rowStyle: { margin: "1px" },
        addNewLineAbove: true,
        radios: [
          {
            label: "Yes",
            value: "Yes",
            type: "radio",
            useLabel: true,
          },
          {
            label: "No",
            value: "No",
            type: "radio",
            useLabel: true,
          },
        ],
      },
      {
        type: "radiogroup",
        name: "question_8",
        required: true,
        label:
          "8. Are you aware of any instances where an end customer has had unlicensed software usage?",
        validator: "isString",
        fieldLableProps: {
          style: { color: "#323232", fontSize: "16.5px" },
          necessity: "required",
        },
        useLabel: true,
        key: "pg_8",
        rowStyle: { margin: "1px" },
        addNewLineAbove: true,
        radios: [
          {
            label: "Yes",
            value: "Yes",
            type: "radio",
            useLabel: true,
          },
          {
            label: "No",
            value: "No",
            type: "radio",
            useLabel: true,
          },
        ],
      },
    ],
  },
  section10: [
    {
      name: "iAgree",
      label: "",
      type: "checkbox",
      key: "pg1_10",
      required: true,
      renderLabel: false,
      fieldLableProps: {
        position: "left",
        style: {
          float: "right",
        },
      },
      useLabel: true,
    },
  ],
};
